// extracted by mini-css-extract-plugin
export default {"main":"EmailVerification_main__GSfhx","message":"EmailVerification_message__Eph7i"};